import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FractionPipe } from './fraction/fraction.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [FractionPipe],
  exports: [FractionPipe],
})
export class PipeModule {}
